import React, { useState } from "react";
import axios from "axios";

export default function LoginPage({ setToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const res = await axios.post(
        "https://api.oohtech.ng/api/TokenAuth/Authenticate",
        { usernameoremailaddress: username, password: password }
      );
      const token = res.data.result.accessToken;
      setToken(token);
      localStorage.setItem("auth_token", token);
      setError("");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };
  // const handleLogin = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("UserNameOrEmailAddress", username);
  //     formData.append("Password", password);

  //     const res = await axios.post(
  //       "https://api.oohtech.ng/api/TokenAuth/Authenticate",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     const token = res.data.result.accessToken;
  //     setToken(token);
  //     localStorage.setItem("auth_token", token);
  //     setError("");
  //   } catch (err) {
  //     setError("Login failed. Please check your credentials.");
  //   }
  // };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Please login to continue</p>
        <input
          className="login-input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="login-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="login-button" onClick={handleLogin}>
          Login
        </button>
        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
}
